<template lang="html">
    <fleets v-if="displayFleetsPageWhenNoSelectedFleet"></fleets>
    <simple-layout
        v-else
        class="logs-home-page"
        :indicators="simpleLayoutIndicators"
        :modelsLoaded="true"
    >
        <el-row>
            <el-col :span='16'><h1>Logs</h1></el-col>
            <el-col :span='8'>
                <select-group v-if="displaySelectGroup" class="select-group-component"></select-group>
            </el-col>
        </el-row>
        <div>
            <ns-paginate
                ref="logsTable"
                baseUrl="inspection-request-log/"
                :listFieldToDisplay="listFieldToDisplay"
                :customFiltersToApply="filterData"
                :filters="filters"
                :scoped="false"
            >
                <template slot="list" slot-scope="props">
                    <el-table
                        :data="props.list"
                    >
                        <template v-for="item in listFieldToDisplay">
                            <el-table-column
                                v-if="item.key == 'creation_date'"
                                label="Date"
                                prop="creation_date">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.creation_date | moment('DD/MM/YYYY HH:mm') }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="item.key == 'created_by'"
                                label="Utilisateur"
                                prop="created_by">
                                 <template slot-scope="scope">
                                    <span>
                                        {{ usersByUid(scope.row.created_by).verbose_name }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="item.key == 'name'"
                                label="Action"
                                prop="name">
                            </el-table-column>
                            <el-table-column
                                v-if="item.key == 'inspection_request'"
                                label="Véhicule concerné">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.inspection_request.plate }}</span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </template>
            </ns-paginate>
        </div>
    </simple-layout>
</template>


<script>
import Fleets from '../Fleets/Index.vue';
import SelectGroup from '@/components/partials/select-group.vue';
import NsPaginate from 'fundation-app-vuejs/src/components/partials/nsPaginate/index.vue';
import { mapGetters } from 'vuex';

export default {

    components: {
        Fleets,
        SelectGroup,
        NsPaginate,
    },

    data () {
        return {
            listFieldToDisplay: [
                {
                    key: 'creation_date',
                    verbose: 'Date ',
                },
                {
                    key: 'created_by',
                    verbose: 'User ',
                },
                {
                    key: 'name',
                    verbose: 'Action ',
                },
                {
                    key: 'inspection_request',
                    verbose: 'Inspection request',
                },
            ],
            filters: [
                // TODO creation_date and created_by filters do not work/are not displayed
                {
                    key: 'creation_date',
                    verbose: 'Date ',
                },
                {
                    key: 'created_by',
                    verbose: 'Users',
                },
                {
                    key: 'name',
                    verbose: 'Actions',
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'displayFleetsPage',
            'usersByUid',
            'getSelectedFleet',
            'isAFleetSelected',
            'displaySelectGroup',
            'simpleLayoutIndicators',
        ]),

        filterData() {
            return () => {
                return this.queryParams;
            };
        },

        queryParams() {
            if(this.isAFleetSelected) {
                return {
                    ordering: 'modification_date',
                    client_group: this.getSelectedFleet
                };
            } else {
                return {
                    ordering: 'creation_date',
                };
            }
        },

        displayFleetsPageWhenNoSelectedFleet() {
            return this.displayFleetsPage && !this.isAFleetSelected;
        },
    },

    watch: {
        '$store.getters.getSelectedFleet'(val) {
            this.$set(this.queryParams, 'client_group', val);
            if(this.$refs['logsTable']) {
                this.$refs['logsTable'].loadContent();
            }
        },
    },


    methods: {
    }
};
</script>

<style lang="scss">
.logs-home-page {

}
</style>



// WEBPACK FOOTER //
// src/components/page/Logs/Index.vue